import { transactionApi } from '@/apis';

export default {
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   * @param {Object} params
   */
  async initRBTMDashboard({ commit, dispatch }, params = {}) {
    commit('reset');
    commit('setLoading', true);
    const requests = [
      dispatch('fetchSummary'),
      dispatch('fetchStatuses'),
      dispatch('fetchTxs', params),
    ];
    await Promise.all(requests);
    commit('setLoading', false);
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   */
  async fetchSummary({ commit, rootGetters }) {
    const token = rootGetters['auth/token'];
    try {
      const response = await transactionApi.requestSummary(token);
      commit('setSummary', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   */
  async fetchStatuses({ commit, rootGetters }) {
    const token = rootGetters['auth/token'];
    try {
      const response = await transactionApi.requestStatuses(token);
      commit('setStatuses', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   * @param {Object} params
   */
  async incrementTxs({ commit, dispatch }, params) {
    commit('setAdding', true);
    await dispatch('fetchTxs', params);
    commit('setAdding', false);
  },
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   * @param {Object} params
   */
  async refreshTxs({ commit, dispatch }, params) {
    commit('setRefreshing', true);
    commit('setItems', []);
    await dispatch('fetchTxs', params);
    commit('setRefreshing', false);
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   * @param {Object} params
   */
  async fetchTxs({ commit, rootGetters }, params) {
    const token = rootGetters['auth/token'];
    try {
      const response = await transactionApi.requestList(token, params);
      if (response.data.result && response.data.result.length > 0) {
        commit('addItems', response.data.result);
      }
      commit('setPaging', response.data.paging);
    }
    catch (error) {
      commit('setError', error);
    }
  },
};
